// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeLeagueCatalogGetBody = {};

export type typeLeagueCatalogGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    sports: {
      sportId: string;
      sportKey: string;
      name: string;
      shortName: string;
      displayOrder: number;
      leagues: {
        leagueId: string;
        leagueKey: string;
        name: string;
        shortName: string;
        abbreviation: string;
        displayOrder: number;
        visibilityState: "hidden" | "comingSoon" | "live";
        isPoolEligible: boolean;
        hasStandings: boolean;
        logoUrl?: string | null;
        poolSeasonYear: number;
        poolSeasonLabel: string;
      }[];
    }[];
  };
};

export type typeLeagueCatalogGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeLeagueCatalogGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeLeagueCatalogGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaLeagueCatalogGetBody = {
  type: "object",
  properties: {},
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createLeagueCatalogGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaLeagueCatalogGetBody);
  }

  return async function postLeagueCatalogGet(
    payload: typeLeagueCatalogGetBody,
  ): Promise<typeLeagueCatalogGetOutput200 | typeLeagueCatalogGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postLeagueCatalogGet" failed before calling the network. #9bc7cd2c016b`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#9bc7cd2c016b" },
        },
        data: null,
      } as typeLeagueCatalogGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/league-catalog/get`,
      httpMethod: "POST",
      options,
    })) as typeLeagueCatalogGetOutput200 | typeLeagueCatalogGetOutput400;
  };
}
